/* tslint:disable */
/* eslint-disable */
/**
 * Business Portal API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート)
 * @export
 * @enum {number}
 */
export enum RouteTypeEnum {
    /** 距離優先 */
    SHORTEST_DISTANCE = '0',
    /** 時間優先 */
    SHORTEST_TIME = '1'
}

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) の Union 型
 * @export
 * @typedef RouteType
 */
export type RouteType =
  typeof RouteTypeEnum[keyof typeof RouteTypeEnum];

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) のラベルマップ
 * @export
 */
export const RouteTypeLabels = {
    /**
     * 数値キー: RouteTypeEnum.SHORTEST_DISTANCE
     * 名前キー:  SHORTEST_DISTANCE
     */
    [RouteTypeEnum.SHORTEST_DISTANCE]: '距離優先',
    SHORTEST_DISTANCE:                             '距離優先',
    /**
     * 数値キー: RouteTypeEnum.SHORTEST_TIME
     * 名前キー:  SHORTEST_TIME
     */
    [RouteTypeEnum.SHORTEST_TIME]: '時間優先',
    SHORTEST_TIME:                             '時間優先',
} as const;

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) のラベル Union 型
 * @export
 * @typedef RouteTypeLabel
 */
export type RouteTypeLabel =
  typeof RouteTypeLabels[keyof typeof RouteTypeLabels];

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) のラベル取得関数
 * @export
 * @param { RouteType } value - 列挙体の値
 * @returns { RouteTypeLabel } ラベル文字列
 */
export function getRouteTypeLabel(
  value: RouteType
): RouteTypeLabel {
  return RouteTypeLabels[value];
}

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) のラベル配列を取得する関数
 * @export
 * @param { RouteType[] } values - 列挙体の値配列
 * @returns { RouteTypeLabel[] } ラベル文字列配列
 */
export function getRouteTypeLabels(values: RouteType[]): RouteTypeLabel[] {
  return values.map((value) => getRouteTypeLabel(value));
}

/**
 * 経路種別 (0:最短距離ルート, 1:最短時間ルート) のラベル配列
 * @export
 */
export const RouteTypeLabelList = [
  '距離優先','時間優先',
] as const;

